import { DatabaseBlockSchema } from '@blocksuite/affine-model';
import {
  BlockPlainTextAdapterExtension,
  type BlockPlainTextAdapterMatcher,
} from '@blocksuite/affine-shared/adapters';

import { formatTable, processTableForExport } from './utils.js';

export const databaseBlockPlainTextAdapterMatcher: BlockPlainTextAdapterMatcher =
  {
    flavour: DatabaseBlockSchema.model.flavour,
    toMatch: () => false,
    fromMatch: o => o.node.flavour === DatabaseBlockSchema.model.flavour,
    toBlockSnapshot: {},
    fromBlockSnapshot: {
      enter: async (o, context) => {
        const { walkerContext, deltaConverter } = context;
        const rows: string[][] = [];
        const table = await processTableForExport(o.node.props, context.job);
        rows.push(table.headers.map(v => v.name));
        table.rows.forEach(v => {
          rows.push(
            v.cells.map(v =>
              typeof v.value === 'string'
                ? v.value
                : deltaConverter.deltaToAST(v.value.delta).join('')
            )
          );
        });

        const tableString = formatTable(rows);

        context.textBuffer.content += tableString;
        context.textBuffer.content += '\n';
        walkerContext.skipAllChildren();
      },
    },
  };

export const DatabaseBlockPlainTextAdapterExtension =
  BlockPlainTextAdapterExtension(databaseBlockPlainTextAdapterMatcher);
